<template>
  <footer>
    <img src="../assets/images/footer/logo.png" class="logo" alt />
    <div class="item-box">
      <a target="_blank" class="item-box-a" href="https://www.arknights.global/privacy_policy">Privacy Policy</a>
      <a target="_blank" class="item-box-a" href="https://www.arknights.global/terms_of_service">Terms of Service</a>
      <a href="mailto:arknights.en.cs@yo-star.com" class="item-box-a ">CONTACT US</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",

  components: {},
  data: () => ({}),
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  padding: pxTorem(13px) pxTorem(20px);
  box-sizing: border-box;
  border-top: 1px solid #333333;
  display: flex;
  justify-content: space-between;
  .logo {
    display: block;
    width: pxTorem(428px);
  }
  .item-box {
    .item-box-a {
      font-size: pxTorem(18px);
      color: #878787;
      padding: 0 pxTorem(6px);
      border-right: 1px solid #000;
      &:hover {
        color: #ffee22;
      }
    }
    .item-box-a:last-of-type{
         border-right: none;
    } 
    .information {
      font-size: pxTorem(18px);
      color: #878787;
    }
  }
}
</style>
